import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { NavService } from "../../../_services/NavService.service";
import { appService } from '../../../_services/app.service';
import { CommonService } from '../../../_services/common.service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { Helpers } from '../../../helpers';
import { ITableModel } from '../../../shared/components/table/model/tableModel';
import { MobileDetectionService } from '../../../shared/services/mobile-detection.service';
import { TranslateConfigService } from '../../../theme/home/translateConfig.service';
import { OrdersService } from '../../../shared/services/orders/orders.service';

@Component({
  selector: 'app-dynamic-report-modal',
  templateUrl: './dynamic-report-modal.component.html',
  styleUrls: ['./dynamic-report-modal.component.scss']
})
export class DynamicReportModalComponent implements OnInit,OnDestroy,OnChanges {

  searchValue: string = '';
  filterObj: any = {
    Status: 'All'
  };
  noOfPages: number = 15;
  totalCount: number = 0;
  TenantId: any;
  CompanyId: any;
  isListApiCalled: boolean;
  userId: any;
  reportHeader: any = [];
  payload: any = {};
  customerId: any;
  viewType: any;
  isDetailsPageShow: any;
  totalOrderCount: any;
  StockDetails: any = [];
  tableDetails:any= {
    emptyDataMSg: "No Records Found",
    data: [],
    columnDetails: [],
    actionList: [],
    isColumnNameShow: true,
  };

  listOfFilter:any = [
      {
        lable: "Vendor",
        dataField: "SupplierId",
        value: this.filterObj.SupplierId,
        isValueBind: true,
        isSearchByApi: true,
        type: "dropdown",
        placeholder: "Select Vendor",
      },
      {
        lable: "Warehouse",
        dataField: "WarehouseName",
        value: this.filterObj.WarehouseName,
        isValueBind: true,
        isSearchByApi: true,
        type: "dropdown",
        placeholder: "Select Warehouse",
        isReadOnly: true
      },
  ]
  hostUrl: any = environment.apiUrl;
  @Input() FilterByProduct: any;
  @Output() onCloseBtnClick = new EventEmitter<any>();
  pageTitle = 'Stock Summary';
  
  WarehouseName:any;
  constructor(
    private router: Router,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private translate: TranslateService,
    private commonService: CommonService,
    private _navService: NavService,
    private service: TranslateConfigService,
    private mobileDetectionService: MobileDetectionService,
    private modalService: NgbModal,
    private orderService: OrdersService
  ) { }

  ngOnInit() {
    this.TenantId = JSON.parse(
    this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const storedPerPage = localStorage.getItem('perPage');
    if (storedPerPage) {
      this.noOfPages = parseInt(storedPerPage, 10);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
      if (changes['FilterByProduct']) {
        this.FilterByProduct = changes['FilterByProduct'].currentValue;
        if (this.FilterByProduct) {
          this.GetStockLedgerList();
        }
      }
  }

  ngOnDestroy() {
    localStorage.removeItem('perPage');
  }

  GetStockLedgerList(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    isFilter = false
  ) {
    Helpers.setLoading(true);
    localStorage.setItem('perPage', perPage);
    this.payload.Start = pageNo * perPage;
    this.payload.Length = perPage;
    this.payload.SearchValue = searchValue;
    this.payload.CompanyId = this.CompanyId;
    this.payload.BillTo = null;
    this.payload.CategoryName = null;
    this.payload.EANCode = null;
    this.payload.FromDate = null;
    this.payload.ToDate = null;
    this.payload.WarehouseName = this.WarehouseName || null;
    this.payload.ProductName = this.FilterByProduct || null;

    this._appService.Post("OperationalReport", "GetStockSummary", this.payload).subscribe((response) => {
      if (response.length) {
        this.totalCount = response[0].Count;
       
        let i = 0;
        response.forEach((value, prop, obj) => {
          if (i == 0) {
            delete value["Count"];
            this.reportHeader = Object.getOwnPropertyNames(value);
          }
          i++;
        });

        this.tableDetails.columnDetails = [];
        for (const item of this.reportHeader) {
          var obj: any = {};
          obj.columnName = item;
          obj.dataFieldName = item;
          this.tableDetails.columnDetails.push(obj);
        }
      }
      this.assignTableFields(pageNo, perPage, response)
      Helpers.setLoading(false);
    },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error(
          this.translate.instant("User.ErrorMessage"),
          "error"
        );
      }
    );
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails, paginationDetails: {
        totalItems: this.totalCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1
      },
      data: data,
    }
  }

  onPageChange(pageNo: number) {
    const storedPerPage = localStorage.getItem('perPage') || this.noOfPages;
    this.GetStockLedgerList(this.searchValue, pageNo - 1, this.filterObj, storedPerPage);
  }

  onPageNumberChange(noOfPages: any) {
    localStorage.setItem('perPage', noOfPages);
    this.noOfPages = noOfPages
    this.GetStockLedgerList(this.searchValue, 0, this.filterObj, noOfPages);
  }

  onFilterSearch(event) {
    if (event.dataField == "SupplierId") {
      this.GetSupplierList(event.searchKeyword, false);
    }
    if (event.dataField == "WarehouseName") {
      this.GetWarehouseNameList(event.searchKeyword, false);
    }
  }

  GetSupplierList(value, isScrollDown = false) {
    this.listOfFilter[0].isSearch = true;
    let pageNo = 1;
    this.orderService.VendorSelect2(value, pageNo, this.TenantId).then((res) => {
      this.orderService.currentCustomerId.subscribe((id) => {
        if (id !== null) {
          this.customerId = id;  // Store the customerId when it's updated
          console.log('Customer ID in orderlist:', this.customerId);
          this.listOfFilter[1].isReadOnly = false;
        }
      });
      this.findObjectOfTheField(this.listOfFilter[0].dataField, res, this.listOfFilter[0]);
      Helpers.setLoading(false);
    })
    .catch((error) => {
      this.listOfFilter[0].isSearch = false;
    });
  }

  GetWarehouseNameList(value, isScrollDown = false) {
    this.listOfFilter[1].isSearch = true;
    this.orderService.ShipperConsigneeSelect2(value, this.customerId, this.userId, this.CompanyId).then((res) => {
      this.findObjectOfTheField(this.listOfFilter[1].dataField, res, this.listOfFilter[1]);
      Helpers.setLoading(false);
    },
      (err) => {
        this.toastr.error("Error occurred while fetching data !", "error");
      });
  }

  findObjectOfTheField(dataField, dropdownList, type) {
    type.dropdownList = dropdownList;
    type.isSearch = false;
    if (type.dataField) {
      type.isReadOnly = false
    }
  }

  onFilterClickApply(event) {
    const filterObject: any = {};
    event.forEach((filter: any) => {
      if (!filter.dataField || filter.value === undefined || filter.value === null) return;
      if (Array.isArray(filter.value)) {
        filterObject[filter.dataField] = filter.value.join(',');
      } else {
        filterObject[filter.dataField] = filter.value;
      }
    });
    this.filterObj = filterObject
    this.GetStockLedgerList();
  }

  BackTofunction() {
    this.onCloseBtnClick.emit()
  }
  
  onFilterClick() {
    console.log();
  }

  callParentList(event){
    this.WarehouseName=event;
    this.GetStockLedgerList();    
  }
}
